<template>
  <div class="soar-container flex flex-col gap-y-4">
    <h1 class="text-xl md:text-2xl text-primary font-medium border-b border-brand-gray-300">
      {{ $t('addresses') }}
    </h1>

    <div v-if="!isLoading" class="w-full flex flex-col gap-y-4">
      <LocalAddresses />
      <DeliveryAddressesIdentity />
      <DeliveryAddressesPassport />
      <AbroadAddresses />
    </div>
  </div>
</template>

<script setup>
import AbroadAddresses from '@/views/auth-user/addresses/AbroadAddresses/index.vue'
import DeliveryAddressesIdentity from '@/views/auth-user/addresses/DeliveryAddressesIdentity/index.vue'
import DeliveryAddressesPassport from '@/views/auth-user/addresses/DeliveryAddressesPassport/index.vue'
import LocalAddresses from '@/views/auth-user/addresses/LocalAddresses/index.vue'
import { onMounted, ref } from 'vue'
import { useIndAddressMgmtStore } from '@/stores/ind_address_mgmt'

const isLoading = ref(true)
const indAddressMgmtStore = useIndAddressMgmtStore()

onMounted(async () => {
  await indAddressMgmtStore.fetchLookups()
  isLoading.value = false
})
</script>

<style lang="scss" scoped></style>
